module.exports = __webpack_public_path__ + "static/media/country-04.020c354e.png";